module.exports = __webpack_public_path__ + "static/media/female-police-officer_1f46e-200d-2640-fe0f.01ad8878.png";